import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent, FormMultiSelectComponent, FormSelectComponent, FormTextareaComponent } from '@shared/forms';
import { CountryCode, COUNTRY_OPTIONS } from '@shared/types';
import { FormOptionsFacade } from '@app/store/form-options';
import { SchoolFacade } from '@app/store/school';

@Component({
    selector: 'app-school-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormInputComponent, FormMultiSelectComponent, FormSelectComponent, FormTextareaComponent],
})
export class AddComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly schoolFacade = inject(SchoolFacade);
    private readonly formOptionsFacade = inject(FormOptionsFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);

    readonly saving = this.schoolFacade.saving;
    readonly countryOptions = COUNTRY_OPTIONS;
    readonly courseOptions = this.formOptionsFacade.courses;

    readonly form = this.formBuilder.group({
        name: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        shortName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        description: this.formBuilder.control(''),
        rollNumber: this.formBuilder.control('', [FormValidators.Text]),
        contactEmail: this.formBuilder.control('', [FormValidators.Text, FormValidators.Email]),
        courseIds: this.formBuilder.control<string[]>([]),
        address: this.formBuilder.group({
            street: this.formBuilder.control(''),
            postalCode: this.formBuilder.control(''),
            city: this.formBuilder.control(''),
            country: this.formBuilder.control<CountryCode | null>('IE', [FormValidators.Required]),
        }),
    });

    constructor() {
        this.formOptionsFacade.getCourses();

        effect(() => {
            if (this.schoolFacade.saved()) {
                this.close();
            }
        });

        effect(() => {
            if (this.schoolFacade.saving() === false && this.schoolFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.schoolFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            this.schoolFacade.createSchool(this.form.getRawValue());
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
